export const prerender = true

export const load = () => ({
  description: 'Start a new Nuzlocke run with the Nuzlocke Tracker app. Pick your game, name your run, and track every encounter from Gen 1 to Gen 9 — free online.'
})
